import React from "react";

import { accentColorLink } from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

const Ripple = styled.div`
  box-sizing: border-box;
  position: relative;
  &:before {
    animation: ${(props) => props.name} 1s ease-out
      ${(props) => (props.count <= 0 ? "infinite" : props.count)};

    bottom: 0;
    box-sizing: border-box;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
  &:after {
    animation: ${(props) => props.name} 1s 0.5s ease-out
      ${(props) => (props.count <= 0 ? "infinite" : props.count)};

    bottom: 0;
    box-sizing: border-box;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
  @keyframes ${(props) => props.name} {
    0% {
      border: solid 1px ${(props) => props.color};
      opacity: 0.5;
    }
    99% {
      opacity: 0;
      transform: scale(2);
    }
    100% {
      border: solid 1px ${(props) => props.color};
    }
  }
`;

const RippleEffectHolder = ({
  color = accentColorLink,
  children,
  count = 1,
  active = true,
  name = "rippleFrames",
}) => {
  return active ? (
    <Ripple color={color} count={count} name={name}>
      {children}
    </Ripple>
  ) : (
    children
  );
};
export default RippleEffectHolder;
